/* eslint-disable vue/one-component-per-file */
import Vue from 'vue'

import nuxtStorage from 'nuxt-storage';

Vue.use(nuxtStorage )

Vue.component('nuxtStorage', nuxtStorage)